import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { modules } from 'veritone-redux-common';

const { auth } = modules;

import sidebar, { namespace as sidebarNamespace } from 'modules/sidebar';
import snackBar, { namespace as snackBarNamespace } from 'modules/snackbar';
import loadingBar, { namespace as loadingBarNamespace } from 'modules/loading';
import boot, { namespace as bootNamespace } from 'modules/boot';
import application, {
  namespace as applicationNamespace,
} from 'modules/application';
import engine, { namespace as engineNamespace } from 'modules/engine';
import engineBuilds, {
  namespace as engineBuildsNamespace,
} from 'modules/engine-builds';
import engineTasks, {
  namespace as engineTasksNamespace,
} from 'modules/engine-tasks';
import flows, { namespace as flowsNamespace } from 'modules/flows';
import libraries, { namespace as librariesNamespace } from 'modules/library';
import user, { namespace as userNamespace } from 'modules/user';
import config, { namespace as configNamespace } from 'modules/config';
import app, { namespace as appNamespace } from 'plugins/app/modules';
import uiState, { namespace as uiStateNamespace } from 'modules/ui-state';
import confirmation, {
  namespace as confirmationNamespace,
} from 'modules/confirmation';
import dataSchema, {
  namespace as dataSchemaNamespace,
} from 'modules/data-schema';
import documentation, {
  namespace as documentationNameSpace,
} from 'modules/documentation';
import aiWare, { namespace as aiWareNameSpace } from 'modules/aiWare';

export default function createReducer(asyncReducers) {
  return combineReducers({
    // global reducers go here. Lazy reducers should be registered in their
    // routes' getComponent with injectAsyncReducer
    routing,
    form: formReducer,
    [sidebarNamespace]: sidebar,
    [snackBarNamespace]: snackBar,
    [loadingBarNamespace]: loadingBar,
    [bootNamespace]: boot,
    [userNamespace]: user,
    [applicationNamespace]: application,
    [engineNamespace]: engine,
    [flowsNamespace]: flows,
    [engineBuildsNamespace]: engineBuilds,
    [engineTasksNamespace]: engineTasks,
    [librariesNamespace]: libraries,
    [configNamespace]: config,
    [appNamespace]: app,
    [uiStateNamespace]: uiState,
    [confirmationNamespace]: confirmation,
    [dataSchemaNamespace]: dataSchema,
    [documentationNameSpace]: documentation,
    [aiWareNameSpace]: aiWare,
    [auth.namespace]: auth.reducer,
    ...asyncReducers,
  });
}

export function injectAsyncReducer(store, name, asyncReducer) {
  store.asyncReducers[name] = asyncReducer;
  store.replaceReducer(createReducer(store.asyncReducers));
}



// WEBPACK FOOTER //
// ./src/client/store/reduxConfig/reducer.js